import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useWalkthroughContext } from './WalkthroughProvider';
import { getTourConfig } from './tourConfigs';

export function WalkthroughButton({ moduleId }) {
  const ctx = useWalkthroughContext();
  if (!ctx) return null;

  const { startTour, resetTour, activeTour } = ctx;

  const handleClick = () => {
    resetTour(moduleId);
    const config = getTourConfig(moduleId);
    if (config) startTour(moduleId, config.steps);
  };

  if (activeTour) return null;

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-slate-500 hover:text-blue-600 bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-200 rounded-lg transition-all"
      title="View guided tour"
      data-testid={`walkthrough-help-btn-${moduleId}`}
    >
      <HelpCircle className="h-3.5 w-3.5" />
      <span className="hidden sm:inline">Guide</span>
    </button>
  );
}
